import _extends from 'babel-runtime/helpers/extends';

import { mapMutations } from 'vuex';

export default {
  props: {
    category: {
      type: Object,
      required: true
    },

    buttonAttrs: {
      type: Object
    },

    origin: {
      type: String,
      validator: function validator(value) {
        return ['cloud', 'local'].some(function (item) {
          return item === value;
        });
      }
    }
  },

  computed: {
    innerButtonAttrs: function innerButtonAttrs() {
      return _extends({
        text: '',
        type: 'text'
      }, this.buttonAttrs);
    }
  },

  methods: _extends({}, mapMutations({
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    openCloudResourcesDialog: 'creative/template/openCloudResourcesDialog',
    openAddLocalResourceDialog: 'creative/template/openAddLocalResourceDialog'
  }), {
    open: function open() {
      if (this.origin === 'cloud') {
        this.openCloudResourcesDialog();
      } else {
        this.openAddLocalResourceDialog({ action: 'add' });
      }

      this.updateCurrentCategory(this.category);
    }
  })
};